// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"080c4b86","787":"b6e5a90a","980":"42e8a718"}[chunkId] + ".chunk.js";
};